import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import GoogleIcon from './Icons';

const GoogleLoginButton = function GoogleLoginButton({
  label = 'Sign in with Google',
  loginUrl,
  ...props
}) {
  return (
    <form action={loginUrl} method="post">
      <Button
        type="submit"
        variant="outlined"
        sx={{
          border: '2px solid #d6d6d6',
          color: 'greys.title',
          textTransform: 'none',
          borderRadius: '10px',
          mb: '16px',
          '&:hover': {
            borderWidth: '2px',
          },
        }}
        fullWidth
        size="medium"
      >
        <GoogleIcon {...props} />
        <span>{label}</span>
      </Button>
    </form>
  );
};

GoogleLoginButton.propTypes = {
  label: PropTypes.string,
  loginUrl: PropTypes.string.isRequired,
};

export default GoogleLoginButton;
